import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp, faThumbsDown } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';

import { submitRecommended, submitRating } from 'Redux/ducks/user-review';
import 'Components/ProductReviews/UserReviews/UserReviewStars.scss';

const RatingAndRecommended = ({
  lightTheme,
  slug,
  reviewData,
  productId,
  buttonsOnly, // simplified version of the componetd with text removed
  updateParentReviewData, // if parent needs to know rating and recommended updates,
}) => {
  const [recommended, setRecommended] = useState(false);
  const [rating, setRating] = useState(undefined);

  const { recommended: _recommended, rating: _rating } = reviewData;

  useEffect(() => {
    setRecommended(_recommended);
    setRating(_rating);
  }, [_recommended, _rating]);

  const submitRatingClick = async (value) => {
    const result = await submitRating({
      rating: value,
      slug,
      product_id: productId,
    });

    setRating(result);
    updateParentReviewData({ ...reviewData, rating: result });
  };

  const submitRecommendedClick = async (value) => {
    const result = await submitRecommended({
      recommended: value,
      slug,
      product_id: productId,
    });

    setRecommended(result);
    updateParentReviewData({ ...reviewData, recommended: result });
  };

  const starRatingButtons = () => {
    const starButtons = [...Array(5).keys()].map((score, index) =>
      <button
        className={classNames('star-rating-button', `star-${index + 1}`, { 'highlighted-star': (index + 1) <= rating })}
        key={score}
        aria-label="Star rating"
        onClick={() => submitRatingClick(index + 1)}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90" preserveAspectRatio="xMinYMid meet" role="img" aria-label="User review star">
          <polygon points="45 0 58.91 29.63 90 34.38 67.5 57.44 72.81 90 45 74.63 17.19 90 22.5 57.44 0 34.38 31.09 29.63 45 0" />
        </svg>
      </button>,
    );

    return starButtons;
  };

  return (
    <div className="rating-and-recommeneded-container">
      <div className="overall-rating-container">
        {!buttonsOnly &&
          <div className="section-title">
            <FormattedMessage id="rateandrecommend.overallrating" defaultMessage="Overall Rating" />
          </div>
        }
        <div className={classNames('star-rating-buttons-container', { 'stars-light-theme': lightTheme })}>
          {starRatingButtons(rating)}
        </div>
      </div>

      <div className="recommended-container">
        {!buttonsOnly &&
          <div className="section-title">
            <FormattedMessage id="rateandrecommend.wouldyourecommendthisgame" defaultMessage="Would you recommend this game?" />
          </div>
        }
        <div className={classNames('recommended-buttons-container', { 'thumbs-light-theme': lightTheme })}>
          <button className={classNames('thumbs-up-button', { 'thumbs-up': recommended === true })} onClick={() => submitRecommendedClick(true)}>
            <div className="d-flex align-items-center">
              <FontAwesomeIcon icon={faThumbsUp} title="Yes" />
              {!buttonsOnly &&
                <div className="button-text">
                  <FormattedMessage id="rateandrecommend.yes" defaultMessage="Yes" />
                </div>
              }
            </div>
          </button>
          <button className={classNames('thumbs-down-button', { 'thumbs-down': recommended === false })} onClick={() => submitRecommendedClick(false)}>
            <div className="d-flex align-items-center">
              <FontAwesomeIcon icon={faThumbsDown} title="No" />
              {!buttonsOnly &&
                <div className="button-text">
                  <FormattedMessage id="rateandrecommend.no" defaultMessage="No" />
                </div>
              }
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};


RatingAndRecommended.propTypes = {
  slug: PropTypes.string,
  reviewData: PropTypes.shape({}),
  productId: PropTypes.string,
  buttonsOnly: PropTypes.bool,
  lightTheme: PropTypes.bool,
  updateParentReviewData: PropTypes.func,
};

RatingAndRecommended.defaultProps = {
  slug: '',
  reviewData: {
    rating: 0,
    recommend: undefined,
    productId: '',
  },
  productId: '',
  buttonsOnly: false,
  lightTheme: false,
  updateParentReviewData: () => {},
};

export default RatingAndRecommended;
